import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";

import environment from "src/utils/environment";
import Dialog from "src/components/Dialog";
import { getPresence } from "src/duck/selectors";
import { getIsInDetachMode } from "src/duck/selectors";
import { detachModeChanged } from "src/duck/actions";
import Presence from "src/constants/presence";

const remote = window.require("@electron/remote");

export default function BeforeAppCloseDialog() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  const isInDetachMode = useSelector(getIsInDetachMode);
  const presence = useSelector(getPresence);

  const onBeforeUnload = useCallback(
    (e) => {
      if (
        (presence === Presence.RECEIVER_CONNECTED ||
          presence === Presence.SENDER_CONNECTED ||
          presence === Presence.SENDER) &&
        !window.deviceChangeDetected
      ) {
        e.returnValue = false;
        if (remote.app) {
          if (isInDetachMode) dispatch(detachModeChanged(false));
          if (!isInDetachMode) setIsOpen(true);
        }
      }
    },
    [presence, isInDetachMode, dispatch]
  );

  const quitApp = useCallback(() => {
    window.removeEventListener("beforeunload", onBeforeUnload);
    remote.app.quit();
  }, [onBeforeUnload]);

  useEffect(() => {
    if (environment.debugMode) return;

    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [onBeforeUnload]);

  return (
    <Dialog
      buttons={[
        { text: t("buttons.no"), onClick: () => setIsOpen(false) },
        {
          text: t("buttons.yes"),
          onClick: quitApp
        }
      ]}
      heading={t("app.beforeAppCloseDialog.heading")}
      text={t("app.beforeAppCloseDialog.text")}
      isOpen={isOpen}
    />
  );
}
